
import { Component, Vue } from "vue-property-decorator";
import moment from "moment";

@Component({
  components: {
    Checkbox: () => import("@/components/Checkbox.vue"),
    Modal: () => import("@/components/Modal.vue")
  }
})
export default class UsersIndex extends Vue {
  title: string = "";
  company: any = {};
  exclusions: any = [];
  exclusionId: number = 0;
  currentExclusion: number = 0;

  mounted() {
    this.init();
  }

  async init() {
    await this.loadCompany();
    this.loadExclusions();
  }

  async loadCompany() {
    let response: any = await (this.$root as any)._post(
      `companies/one/${this.$route.params.id}`,
      {
        models: "exclusions"
      }
    );
    this.company = response.data[0];
    this.title = `Actualizar Exclusiones de ${this.company.name}`;
  }

  async addExclusion() {
    await (this.$root as any)._post("companiesexclusions", {
      companyId: this.$route.params.id,
      exclusionId: this.exclusionId,
      percent: 0
    });
    this.init();
    (this.$root as any).notify("Se agrego la exclusión con éxito.");
  }

  async loadExclusions() {
    const response: any = await (this.$root as any)._get("exclusions/all");
    this.exclusions = response.data.filter(
      (c: any) => !this.company.exclusions.some((cc: any) => cc.id === c.id)
    );
    this.exclusionId = 0;
  }

  async updateExclusions() {
    for (let i: number = 0; i < this.company.exclusions.length; i++) {
      await (this.$root as any)._put(
        `companiesexclusions/${this.$route.params.id}/${
          this.company.exclusions[i].id
        }`,
        {
          percent: this.company.exclusions[i].companies_exclusions.percent
        }
      );
    }
    (this.$root as any).notify("Se realizo la actualización con éxito.");
  }

  async deleteExclusion() {
    try {
      let response: any = await (this.$root as any)._delete(
        `companiesexclusions/${this.$route.params.id}/${this.currentExclusion}`
      );
      (this.$refs.modal as any).hide();
      this.init();
    } catch (e) {
      (this.$root as any).notify("No se pudo eliminar la exclusión.", "error");
    }
  }

  showDeleteModal(id: number) {
    this.currentExclusion = id;
    (this.$refs.modal as any).show();
  }
}
